import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import styles from "./holdingsDashboard.module.scss";
import Backfill from "src/components/backfill/backfill";
import _ from "lodash";
import StepNumberInput from "src/components/inputs/step-number-input";
import { ERROR_MESSAGE_UNPLEDGE } from "src/utils/constant";
const { REACT_APP_ENV } = process.env;
const Unpledge = (props) => {
    const [unPledgeData, setUnPledgeData] = useState(props.unpledgeData);
    const [Error, setError] = useState(false);
    const [sortType, setSortType] = useState("Symbol");
    const [sortOrderType, setSortOrderType] = useState("asc");
    const handleIncrement = (id, maxQtn) => {
        const arr = [...unPledgeData];
        unPledgeData.forEach((element, index) => {
            if (element.ScripName === id.ScripName) {
                if (maxQtn >= id.UnPledgeQty) {
                    setError(true);
                }
                else {
                    arr[index].unPledgeMargin += 1;
                    setError(false);
                }
            }
        });
        setUnPledgeData(arr);
        props.setsubmit(arr);
    };
    const handleDecrement = (id) => {
        const arr = [...unPledgeData];
        unPledgeData.forEach((element, index) => {
            if (element.ScripName === id.ScripName) {
                if (element.unPledgeMargin > id.UnPledgeQty) {
                    setError(true);
                    if (id.unPledgeMargin > 0) {
                        arr[index].unPledgeMargin -= 1;
                    }
                }
                else {
                    if (id.unPledgeMargin > 0) {
                        setError(false);
                        arr[index].unPledgeMargin -= 1;
                    }
                }
            }
        });
        setUnPledgeData(arr);
        props.setsubmit(arr);
    };
    //@typescript-eslint/explicit-function-return-type
    const getArrowStyle = (localSortType) => {
        let returnStyle = styles.sortArrow;
        if (sortType == localSortType) {
            if (sortOrderType == "asc")
                returnStyle = styles.sortAsc;
            else if (sortOrderType == "desc")
                returnStyle = styles.sortDesc;
        }
        return returnStyle;
    };
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const incrementSortOrderType = () => {
        let newSortOrderType = "desc";
        if (!sortOrderType) {
            newSortOrderType = "asc";
        }
        else if (sortOrderType == "asc") {
            newSortOrderType = "desc";
        }
        else if (sortOrderType == "desc") {
            newSortOrderType = false;
            setSortType("");
        }
        setSortOrderType(newSortOrderType);
        // return newSortOrderType;
    };
    const sortDataCallback = () => {
        let newSortedList = unPledgeData;
        // The time taken in the switch statement is independent of the number of case. It then basically becomes O(1) time complexity
        switch (sortType) {
            case "Symbol":
                newSortedList = _.orderBy(unPledgeData, ["ScripName"], [sortOrderType]);
                break;
            case "UnPledgeQty":
                newSortedList = _.orderBy(unPledgeData, ["UnPledgeQty"], [sortOrderType]);
                break;
            case "unPledgeMargin":
                newSortedList = _.orderBy(unPledgeData, ["unPledgeMargin"], [sortOrderType]);
                break;
        }
        setUnPledgeData(newSortedList);
    };
    useEffect(() => {
        sortDataCallback();
    }, [sortType, sortOrderType]);
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const onSortTypeChange = (newValue) => {
        if (newValue != sortType) {
            setSortType(newValue);
            setSortOrderType("asc");
        }
        else {
            incrementSortOrderType();
        }
    };
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: styles.modalBodyPart }, { children: unPledgeData && unPledgeData.length > 0 ? (_jsxs("div", Object.assign({ className: "unpledge-data" }, { children: [_jsxs("table", Object.assign({ className: `w-100 unpledge-table` }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsxs("th", { children: ["Scrip", " ", _jsx("span", { className: getArrowStyle("Symbol"), onClick: () => {
                                                        onSortTypeChange("Symbol");
                                                    } })] }), _jsxs("th", Object.assign({ className: "text-center" }, { children: ["Pledge Qty", _jsx("span", { className: getArrowStyle("UnPledgeQty"), onClick: () => {
                                                        onSortTypeChange("UnPledgeQty");
                                                    } })] })), _jsxs("th", Object.assign({ className: "text-right" }, { children: ["Unpledge Qty", "", _jsx("span", { className: getArrowStyle("unPledgeMargin"), onClick: () => {
                                                        onSortTypeChange("unPledgeMargin");
                                                    } })] }))] }) }), _jsx("tbody", { children: unPledgeData &&
                                    unPledgeData.map((item, index) => (_jsxs("tr", { children: [_jsx("td", { children: item.ScripName }), _jsx("td", Object.assign({ className: "text-center" }, { children: item.UnPledgeQty })), _jsx("td", Object.assign({ className: "text-right d-flex justify-content-end" }, { children: _jsx("div", Object.assign({ className: "holdingsStepinputControl" }, { children: _jsx(StepNumberInput, { inputLabel: "", defaultValue: item.unPledgeMargin, stepInput: 1, errorMessage: "Invalid Qty", showError: item.unPledgeMargin > item.UnPledgeQty
                                                            ? true
                                                            : false, errorInfo: true, allowZero: true, toolTipErrorMessage: ERROR_MESSAGE_UNPLEDGE, returnValue: (a) => {
                                                            if (!isNaN(a)) {
                                                                const custInput = a;
                                                                const arr = [...unPledgeData];
                                                                arr[index].unPledgeMargin = custInput;
                                                                setUnPledgeData(arr);
                                                                props.setsubmit(arr);
                                                            }
                                                        } }) })) }))] }, index))) })] })), Error && Error === true && (_jsx("span", Object.assign({ className: "error-msg text-center negativeText" }, { children: "Entered quantity should not be greater than pledge quantity" })))] }))) : (_jsx("div", Object.assign({ className: `${styles.backfillLoaderContainer}` }, { children: _jsx(Backfill, { errorMessage: " Sorry! No record found." }) }))) })) }));
};
export default Unpledge;
